import { productForSkuIdSelector } from '../selectors/ProductsSelectors';
import { useAppSelector } from '../reducers';
export const useContainsProductLevels = productConfigurations => {
  const productLevels = useAppSelector(state => productConfigurations.map(({
    skuId
  }) => {
    const {
      productLevel
    } = productForSkuIdSelector(state, {
      skuId
    });
    return productLevel;
  }));
  return {
    containsStarter: productLevels.includes('STARTER'),
    containsProfessional: productLevels.includes('PROFESSIONAL'),
    containsEnterprise: productLevels.includes('ENTERPRISE')
  };
};